<!-- 生成对账单 -->
<template>
  <div id="ClearingBill">
    <el-button
      class="glo_bgcMainColor saveBtn"
      @click="createBill"
    >保存</el-button>
    <div
      class="formPanel"
      ref="formPanel"
    >
      <el-form
        :model="baseInForm"
        :rules="baseInFormRules"
        ref="baseInForm"
        inline-message
        status-icon
        label-width="100px"
        class="glo_formBox"
      >
        <el-form-item
          label="对账单号:"
          prop="number"
        >
          <el-input
            v-model="baseInForm.number"
            disabled
            placeholder="自动生成"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="结算对象类型:"
          prop="objectStatus"
        >
          <el-input
            v-model="baseInForm.objectStatus"
            disabled
            placeholder="自动生成"
            clearable
          />
          <!-- <el-select v-model="baseInForm.objectStatus" placeholder="请选择">
            <el-option
              v-for="(item, index) in objectStatusArr"
              :key="index"
              :label="item.val"
              :value="item.confDictId"
            />
          </el-select>-->
        </el-form-item>
        <el-form-item
          label="结算对象:"
          prop="objectName"
        >
          <el-input
            v-model="baseInForm.objectName"
            disabled
            placeholder="自动生成"
            clearable
          />
          <!-- <el-select v-model="baseInForm.objectName" placeholder="请选择">
            <el-option
              v-for="(item, index) in objectNameArr"
              :key="index"
              :label="item.val"
              :value="item.confDictId"
            />
          </el-select>-->
        </el-form-item>
        <el-form-item
          label="业务网点:"
          prop="businessDeptId"
        >
          <el-select
            v-model="baseInForm.businessDeptId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in businessDeptIdArr"
              :key="index"
              :label="item.departmentName"
              :value="item.deptId"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="对账网点:"
          prop="reconciliationDeptId"
        >
          <el-select
            v-model="baseInForm.reconciliationDeptId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in reconciliationDeptIdArr"
              :key="index"
              :label="item.departmentName"
              :value="item.deptId"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="对账月份:"
          prop="financeInAmount"
        >
          <el-date-picker
            v-model="baseInForm.statementMoth"
            class="input"
            value-format="yyyy-MM"
            type="month"
            placeholder="请选择"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="应收合计:">
          <el-input
            disabled
            v-model="baseInFormlast.financeInAmount"
            placeholder="自动生成"
            clearable
          />
        </el-form-item>
        <el-form-item label="应付合计:">
          <el-input
            disabled
            v-model="baseInFormlast.financeOutAmount"
            placeholder="自动生成"
            clearable
          />
        </el-form-item>
        <el-form-item label="结算金额:">
          <el-input
            disabled
            v-model="baseInFormlast.settlementAmount"
            placeholder="自动生成"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="核准金额:"
          prop="approvalAmount"
        >
          <el-input
            v-model="baseInForm.approvalAmount"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="核准金额:"
          prop="approvalAmount"
        >
          <el-input
            v-model="baseInForm.approvalAmount"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item
          class="textArea"
          style="width: 100%"
          label="备注:"
          prop="reconciliationRemark"
        >
          <el-input
            type="textarea"
            rows="2"
            v-model="baseInForm.reconciliationRemark"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="
          width: 100%;
          display: flex;
          align-items: center;
          margin-bottom: 16px;
        ">
      <el-button
        class="jsBtns glo_bgcMainColor"
        @click="clickOneSharing"
      >一键合计</el-button>
    </div>
    <table-plug
      :tableConfig="tableConfig"
      :defaulthead="myTableHeard"
      :showSumm="false"
      @selectChange="handleSelectionChange"
    />
    <div
      class="btns"
      ref="btns"
    >
      <el-button
        class="BillBtns"
        @click="ADDARAP"
      >添加应收应付单</el-button>
      <el-button
        class="BillBtns"
        @click="ADDARAP1"
      >批量添加应收单</el-button>
      <el-button
        class="BillBtns"
        @click="ADDARAP2"
      >批量添加应付单</el-button>
      <el-button
        class="BillBtns"
        @click="remove"
      >移除</el-button>
      <el-button
        class="BillBtns"
        @click="prite"
      >打印</el-button>
    </div>
    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />

    <my-dialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <el-form
        :model="formData"
        v-if="isShowDialog"
        label-width="100px"
      >
        <el-form-item
          label="收支类型"
          prop="category"
          style="margin-bottom: 0px"
        >
          <el-select
            v-model="formData.category"
            placeholder="请选择活动区域"
          >
            <el-option
              label="应收"
              :value="1"
            />
            <el-option
              label="应付"
              :value="2"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="收支单据号"
          prop="number"
        >
          <el-select
            v-model="formData.number"
            filterable
            remote
            clearable
            :remote-method="remoteSearch"
            @change="changeVal"
            :loading="loading"
            placeholder="请输入关键词"
          >
            <el-option
              v-for="item in numberArr"
              :key="item.value"
              :label="item.number"
              :value="item.number"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </my-dialog>
    <!-- 批量添加应收单 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3"
    >
      <div
        class="glo_dialogForm"
        v-if="isShowDialog3"
      >
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form
            class="glo_form hasMoreParam"
            label-position="left"
          >
            <el-form-item class="queryItemsTimes">
              <multitime
                :timeType="timeType3"
                :timeTypes="timeTypes3"
                :startTime="startTime_a3"
                :endTime="endTime_a3"
                @timestatus="timestatus3"
                @queryBtn_ok="queryBtn_time3"
              ></multitime>
            </el-form-item>
            <el-form-item
              class="queryItems"
              label="收支单据号:"
            >
              <el-input
                clearable
                v-model="queryData3.number"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="clickQuery3"
            >查询</el-button>
          </el-form>
        </div>
        <div class="glo_Table">
          <el-table
            height="450"
            header-align="center"
            ref="mytable3"
            @row-click="rowclick3"
            :data="tableData3"
            border
            stripe
            @selection-change="handleSelectionChange3"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard3">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
        <paging
          ref="pags3"
          :pageNum="queryData3.pageStart"
          :total="pageCount3"
          :size="queryData3.pageTotal"
          @handleSizeChange="handleSizeChange3"
          @handleCurrentChange="handleCurrentChange3"
        />
      </div>
    </myDialog>
    <!-- 批量添加应付单 -->
    <myDialog
      :diaWidth="diaWidth4"
      :dialogTitle="dialogTitle4"
      :isShowDialog="isShowDialog4"
      @handleCloseDia="handleCloseDia4"
      @diaCancelBtn="handleCloseDia4"
      @diaConfirmBtn="diaConfirmBtn4"
    >
      <div
        class="glo_dialogForm"
        v-if="isShowDialog4"
      >
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form
            class="glo_form hasMoreParam"
            label-position="left"
          >
            <el-form-item class="queryItemsTimes">
              <multitime
                :timeType="timeType4"
                :timeTypes="timeTypes4"
                :startTime="startTime_a4"
                :endTime="endTime_a4"
                @timestatus="timestatus4"
                @queryBtn_ok="queryBtn_time4"
              ></multitime>
            </el-form-item>
            <el-form-item
              class="queryItems"
              label="收支单据号:"
            >
              <el-input
                clearable
                placeholder="请输入"
                v-model="queryData4.number"
              ></el-input>
            </el-form-item>
            <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="clickQuery4"
            >查询</el-button>
          </el-form>
        </div>
        <div class="glo_Table">
          <el-table
            height="450"
            header-align="center"
            ref="mytable4"
            @row-click="rowclick4"
            :data="tableData4"
            border
            stripe
            @selection-change="handleSelectionChange4"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard4">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
        <paging
          ref="pags4"
          :pageNum="queryData4.pageStart"
          :total="pageCount4"
          :size="queryData4.pageTotal"
          @handleSizeChange="handleSizeChange4"
          @handleCurrentChange="handleCurrentChange4"
        />
      </div>
    </myDialog>
  </div>
</template>
<script >
import TablePlug from '@/components/Modules/TablePlug.vue'
import paging from '@/components/pagings.vue' //分页组件
import MyDialog from '@/components/Dialog.vue'
import multitime from '@/components/multiTime.vue'
import _ from 'lodash'

export default {
  inject: ['reload'],
  components: {
    TablePlug,
    paging,
    MyDialog,
    multitime,
  },

  data() {
    return {
      GetStatementFinanceListID: '',
      baseInForm: {
        statementMoth: '',
        financeInAmount: 0,
        financeOutAmount: 0,
        number: null,
        objectStatus: null,
        objectName: null,
        settlementAmount: 0,
        approvalAmount: 0,
        businessDeptId: null,
        reconciliationDeptId: null,
        reconciliationRemark: null,
      },
      baseInFormRules: {
        statementMoth: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        reconciliationDeptId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        businessDeptId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        approvalAmount: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
      },
      defaultBaseInForm: {
        statementMoth: '',
        approvalAmount: null,
        businessDeptId: null,
        reconciliationDeptId: null,
        reconciliationRemark: null,
      },
      // objectStatusArr: [],
      // objectNameArr: [],
      businessDeptIdArr: [],
      reconciliationDeptIdArr: [],
      financeReqs: {},
      // 表格配置
      tableConfig: {
        tableHeigth: '75vh',
        tableData: [],
      },
      myTableHeard: [
        {
          name: '业务日期',
          field: 'createTime',
          width: '120',
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '收支单据号',
          field: 'number',
          width: '120',
          isShow: true,
        },
        {
          name: '责任部门',
          field: 'dutyDeptName',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '收支类型',
          field: 'financeTypeShow',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '单据类型',
          field: 'documentStatusShow',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '来源单据',
          field: 'documentNumber',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '费项类型',
          field: 'categoryName',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '费项',
          field: 'serviceName',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '结算对象类型',
          field: 'objectStatus',
          width: '140',
          sort: 4,
          isShow: true,
        },
        {
          name: '结算对象',
          field: 'objectName',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '金额',
          field: 'settlementAmount',
          width: '120',
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '备注',
          field: 'comment',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '对账单号',
          field: 'accountStatementNumber',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '审核状态',
          field: 'approveStatusShow',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '审核人',
          field: 'approverUserName',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '核销状态',
          field: 'writeoffStatusShow',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '最新核销人',
          field: 'writeoffUserName',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '最新核销时间',
          field: 'writeoffTime',
          width: '140',
          sort: 4,
          isShow: true,
        },
        {
          name: '最新资金账号',
          field: 'zjAccount',
          width: '140',
          sort: 4,
          isShow: true,
        },
        {
          name: '最新核销备注',
          field: 'writeoffComment',
          width: '160',
          sort: 4,
          isShow: true,
        },
      ],
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      // 弹窗
      diaWidth: '40%',
      dialogTitle: '提示',
      isShowDialog: false,
      loading: false,
      numberArr: [],
      CheckedData: {},
      formData: {
        category: 1,
      },
      selectTableData: [],
      statemenNumber: null,
      DefaultTableData: [],

      isShowDialog3: false,
      dialogTitle3: '批量添加应收单',
      diaWidth3: '90%',
      tableData3: [],
      myTableHeard3: [
        {
          name: '收支单据号',
          field: 'number',
          width: '120',
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: '责任部门',
          field: 'dutyDeptName',
          width: '120',
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '收支类型',
          field: 'financeTypeShow',
          width: '120',
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '单据类型',
          field: 'documentStatusShow',
          width: '120',
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '来源单据',
          field: 'documentNumber',
          width: '120',
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '费项类型',
          field: 'categoryName',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '费项',
          field: 'serviceName',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '结算对象类型',
          field: 'objectStatus',
          width: '140',
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '结算对象',
          field: 'objectName',
          width: '120',
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '结算金额',
          field: 'settlementAmount',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '已核销金额',
          field: 'writeoffAmount',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '剩余核销金额',
          field: 'unwriteoffAmount',
          width: '140',
          sort: 2,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '结算方式',
          field: 'settlementMethod',
          width: '120',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: '备注',
          field: 'comment',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '对账单号',
          field: 'accountStatementNumber',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '审核状态',
          field: 'approveStatusShow',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '审核人',
          field: 'approverUserName',
          width: '120',
          sort: 180,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: '核销状态',
          field: 'writeoffStatusShow',
          width: '120',
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '最新核销人',
          field: 'writeoffUserName',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: '最新核销时间',
          field: 'writeoffTime',
          width: '140',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '最新资金账号',
          field: 'zjAccount',
          width: '140',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '最新核销备注',
          field: 'writeoffComment',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: '过账时间',
          field: 'createTime',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
      ],
      selectTableData3: [], //收发地址 表格选择
      //  -----  查询  ------
      queryData3: {
        number: '',
        startCreateTime: '',
        endCreateTime: '',
        pageStart: 1, //  页码
        pageTotal: this.$COMMON.pageTotals, //  一页几条
      }, //  表单查询数据
      pageCount3: 0, //  总条数
      //  时间类型
      timeTypes3: [
        {
          value: '0',
          label: '业务日期',
        },
      ],
      timeType3: '0', //  时间类型
      startTime_a3: '',
      endTime_a3: '',

      isShowDialog4: false,
      dialogTitle4: '批量添加应付单',
      diaWidth4: '90%',
      tableData4: [],
      myTableHeard4: [
        {
          name: '收支单据号',
          field: 'number',
          width: '120',
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '责任部门',
          field: 'dutyDeptName',
          width: '120',
          sort: 4,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '收支类型',
          field: 'financeTypeShow',
          width: '120',
          sort: 5,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '单据类型',
          field: 'documentStatusShow',
          width: '120',
          sort: 5,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '来源单据',
          field: 'documentNumber',
          width: '120',
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '费项类型',
          field: 'categoryName',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '费项',
          field: 'serviceName',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '结算对象类型',
          field: 'objectStatus',
          width: '120',
          sort: 18,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '结算对象',
          field: 'objectName',
          width: '120',
          sort: 19,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '结算金额',
          field: 'settlementAmount',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '已核销金额',
          field: 'writeoffAmount',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '剩余核销金额',
          field: 'unwriteoffAmount',
          width: '160',
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '结算方式',
          field: 'settlementMethod',
          width: '120',
          sort: 2,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '备注',
          field: 'comment',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '对账单号',
          field: 'accountStatementNumber',
          width: '120',
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: '审核状态',
          field: 'approveStatusShow',
          width: '120',
          sort: 1,
          isShow: true,
        },
        {
          name: '审核人',
          field: 'approverUserName',
          width: '120',
          sort: 180,
          isShow: true,
        },

        {
          name: '核销状态',
          field: 'writeoffStatusShow',
          width: '120',
          sort: 6,
          isShow: true,
        },
        {
          name: '最新核销人',
          field: 'writeoffUserName',
          width: '120',
          sort: 1,
          isShow: true,
        },

        {
          name: '最新核销时间',
          field: 'writeoffTime',
          width: '160',
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: '最新资金账号',
          field: 'zjAccount',
          width: '160',
          sort: 1,
          isShow: true,
        },
        {
          name: '最新核销备注',
          field: 'writeoffComment',
          width: '120',
          sort: 1,
          isShow: true,
        },
        {
          name: '过账时间',
          field: 'createTime',
          width: '120',
          sort: 1,
          isShow: true,
          isSort: true,
        },
      ],
      selectTableData4: [], //收发地址 表格选择
      //  -----  查询  ------
      queryData4: {
        number: '',
        startCreateTime: '',
        endCreateTime: '',
        pageStart: 1, //  页码
        pageTotal: this.$COMMON.pageTotals, //  一页几条
      }, //  表单查询数据
      pageCount4: 0, //  总条数
      //  时间类型
      timeTypes4: [
        {
          value: '0',
          label: '业务日期',
        },
      ],
      timeType4: '0', //  时间类型
      startTime_a4: '',
      endTime_a4: '',
      baseInFormlast: {},
    }
  },
  computed: {},
  activated() {
    // 每次进页面都会触发的写这里
    this.height()
    let statementNum = this.$route.query.statementNum
    let add = this.$route.query.add
    let category = this.$route.query.category
    if (add || statementNum || category) {
      this.$refs['baseInForm'].resetFields()
      this.baseInForm.statementId = null
      this.selectTableData.length = 0
      this.tableConfig.tableData = []
      this.DefaultTableData = []
      this.pageStart = 1 //  页码
      this.pageCount = 0 //  总条数
      this.pageTotal = 20 //  一页几条
      this.GetStatementFinanceListID = ''
    }

    if (statementNum) {
      this.GetStatementList(this.$route.query.statementNum)
    }
    if (category) {
      let sessionData = JSON.parse(sessionStorage.getItem('Bill'))
      if (sessionData.val.length > 0) {
        for (let i in sessionData.val) {
          if (sessionData.val[i].type === 'financeIn') {
            this.getFinanceInAllList(sessionData.val[i].number)
          }
          if (sessionData.val[i].type === 'financeOut') {
            this.getFinanceOutAllList(sessionData.val[i].number)
          }
        }
      }
    }
  },
  created() {
    this.GetDept()
    // this.getConfDictValDownList("object_status");
  },
  watch: {
    'baseInForm.financeInAmount': {
      handler(nv, ov) {
        if (typeof nv === 'string') {
          this.baseInForm.financeInAmount = Number(nv)
        }
        this.baseInForm.settlementAmount = this.baseInForm.approvalAmount =
          this.baseInForm.financeInAmount - this.baseInForm.financeOutAmount
      },
    },
    'baseInForm.financeOutAmount': {
      handler(nv, ov) {
        if (typeof nv === 'string') {
          this.baseInForm.financeOutAmount = Number(nv)
        }
        this.baseInForm.settlementAmount = this.baseInForm.approvalAmount =
          this.baseInForm.financeInAmount - this.baseInForm.financeOutAmount
      },
    },
  },

  methods: {
    clickOneSharing() {
      // 正常提交
      let param = {
        statementMoth: this.baseInForm.statementMoth,
      }
      for (let key in this.defaultBaseInForm) {
        if (this.baseInForm[key] || this.baseInForm[key] == 0) {
          eval('param.' + key + "='" + this.baseInForm[key] + "'")
        } else {
          eval('param.' + key + "=''")
        }
      }
      if (this.baseInForm.statementId) {
        param.statementId = this.baseInForm.statementId
        param.financeReqs = []
      }
      if (param.statementId) {
        // 修改对账单
        for (let i in this.tableConfig.tableData) {
          let flag = this.DefaultTableData.findIndex(
            (elem) => elem.financeId === this.tableConfig.tableData[i].financeId
          )
          if (flag == -1) {
            param.financeReqs.push({
              financeId: this.tableConfig.tableData[i].financeId,
              financeType: this.tableConfig.tableData[i].financeType,
              operationType: 'ADD',
            })
          }
          if (
            flag != -1 &&
            this.DefaultTableData[flag].operationType == 'UNCHANGED'
          ) {
            param.financeReqs.push({
              financeId: this.tableConfig.tableData[i].financeId,
              financeType: this.tableConfig.tableData[i].financeType,
              operationType: 'UNCHANGED',
            })
          }
          if (
            flag != -1 &&
            this.DefaultTableData[flag].operationType == 'DEL'
          ) {
            param.financeReqs.push({
              financeId: this.tableConfig.tableData[i].financeId,
              financeType: this.tableConfig.tableData[i].financeType,
              operationType: 'DEL',
            })
          }
        }
      } else {
        // 新建对账单
        for (let i in this.tableConfig.tableData) {
          param.financeReqs.push({
            financeId: this.tableConfig.tableData[i].financeId,
            financeType: this.tableConfig.tableData[i].financeType,
          })
        }
      }

      this.$API.sumStatementFinanceAmount(param).then((res) => {
        if (res.data.status === 'success') {
          let result = res.data.result || {}
          this.$message.success(`一键合计成功`)
          this.baseInFormlast = result
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    ADDARAP1() {
      this.startTime_a3 = this.$TOOLS.getFlexDate(this.$COMMON.timeNum)
      this.endTime_a3 = this.$TOOLS.getCurrentDate()
      this.isShowDialog3 = true
      this.clickQuery3()
    },
    // 批量添加应收单
    queryBtn_time3(s, e) {
      this.startTime_a3 = s || ''
      this.endTime_a3 = e || ''
    }, // 时间组件 选择类型后触发
    timestatus3(type, s, e) {
      this.timeType3 = type || '0'
      this.startTime_a3 = s || ''
      this.endTime_a3 = e || ''
    },
    //批量添加应收单
    handleCloseDia3() {
      this.isShowDialog3 = false
      this.queryData3 = {
        number: '',
        startCreateTime: '',
        endCreateTime: '',
      }
    },
    //批量添加应收单  弹窗确认保存事件
    diaConfirmBtn3() {
      if (!this.selectTableData3.length) {
        this.$message.error(`请选择操作数据`)
        return false
      }
      this.tableConfig.tableData = this.arrayFilter(
        [...this.selectTableData3, ...this.tableConfig.tableData],
        'number'
      )
      this.isShowDialog3 = false
    },
    arrayFilter(arr, key) {
      return arr.filter((item, index, self) => {
        // 利用findIndex方法找到第一个与当前元素id相等的元素索引
        const i = self.findIndex((t) => t[key] === item[key])
        // 如果当前索引等于当前元素在self中的最初出现位置索引，则表示元素符合要求，不是重复元素，保留
        return i === index
      })
    },
    //批量添加应收单 点击选中当前行
    rowclick3(row, event, column) {
      this.$refs.mytable3.toggleRowSelection(row)
    },
    //批量添加应收单 表格选择事件
    handleSelectionChange3(e) {
      this.selectTableData3 = e
    },
    clickQuery3() {
      let startTime = this.startTime_a3 ? this.startTime_a3 + ' 00:00:00' : ''
      let endTime = this.endTime_a3 ? this.endTime_a3 + ' 23:59:59' : ''
      if (this.timeType3 == '0') {
        this.queryData3.startCreateTime = startTime
        this.queryData3.endCreateTime = endTime
      }
      let param = {
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        ...this.queryData3,
      }

      return this.$API.FinanceInAllList(param).then((res) => {
        if (res.data.status === 'success') {
          this.tableData3 = res.data.result.data || []
          this.pageCount3 = res.data.result.pageCount || 0
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`)
        }
      })
    },

    ADDARAP2() {
      this.isShowDialog4 = true
      this.startTime_a4 = this.$TOOLS.getFlexDate(this.$COMMON.timeNum)
      this.endTime_a4 = this.$TOOLS.getCurrentDate()
      this.isShowDialog4 = true
      this.clickQuery4()
    },
    // 批量添加应付单
    queryBtn_time4(s, e) {
      this.startTime_a4 = s || ''
      this.endTime_a4 = e || ''
    }, // 时间组件 选择类型后触发
    timestatus4(type, s, e) {
      this.timeType4 = type || '0'
      this.startTime_a4 = s || ''
      this.endTime_a4 = e || ''
    },
    //批量添加应付单
    handleCloseDia4() {
      this.isShowDialog4 = false
      this.queryData4 = {
        number: '',
        startCreateTime: '',
        endCreateTime: '',
      }
    },
    //批量添加应付单  弹窗确认保存事件
    diaConfirmBtn4() {
      if (!this.selectTableData4.length) {
        this.$message.error(`请选择操作数据`)
        return false
      }
      this.tableConfig.tableData = this.arrayFilter(
        [...this.selectTableData4, ...this.tableConfig.tableData],
        'number'
      )
      this.isShowDialog4 = false
    },
    //批量添加应付单 点击选中当前行
    rowclick4(row, event, column) {
      this.$refs.mytable4.toggleRowSelection(row)
    },
    //批量添加应付单 表格选择事件
    handleSelectionChange4(e) {
      this.selectTableData4 = e
    },
    clickQuery4() {
      let startTime = this.startTime_a4 ? this.startTime_a4 + ' 00:00:00' : ''
      let endTime = this.endTime_a4 ? this.endTime_a4 + ' 23:59:59' : ''
      if (this.timeType4 == '0') {
        this.queryData4.startCreateTime = startTime
        this.queryData4.endCreateTime = endTime
      }
      let param = {
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        ...this.queryData4,
      }

      return this.$API.FinanceOutAllList(param).then((res) => {
        if (res.data.status === 'success') {
          this.tableData4 = res.data.result.data || []
          this.pageCount4 = res.data.result.pageCount || 0
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`)
        }
      })
    },

    // 远程搜索
    remoteSearch(query) {
      let category = this.formData.category
      if (category == 1 && query !== '') {
        this.$API
          .FinanceInAllList({
            number: query,
            writeoffStatus: ' wei_he_xiao:writeoff_status',
          })
          .then((res) => {
            if (res.data.status === 'success') {
              this.loading = false
              this.numberArr = res.data.result?.data || []
            } else {
              this.$message.error(`${res.data.message}`)
            }
          })
      } else if (category == 2 && query !== '') {
        this.$API
          .FinanceOutAllList({
            number: query,
            writeoffStatus: ' wei_he_xiao:writeoff_status',
          })
          .then((res) => {
            if (res.data.status === 'success') {
              this.loading = false
              this.numberArr = res.data.result?.data || []
            } else {
              this.$message.error(`${res.data.message}`)
            }
          })
      } else {
        this.numberArr = []
      }
    },

    // 获取应收总表数据
    getFinanceInAllList(query) {
      this.$API
        .FinanceInAllList({
          number: query,
          writeoffStatus: 'wei_he_xiao:writeoff_status',
        })
        .then((res) => {
          if (res.data.status === 'success') {
            let data = res.data.result?.data || []
            // 计算应收应付
            this.baseInForm.financeInAmount += Number(data[0].settlementAmount)
            this.tableConfig.tableData.push(data[0])
            if (this.tableConfig.tableData.length == 1) {
              this.baseInForm.objectStatus = data[0].objectStatus
              this.baseInForm.objectName = data[0].objectName
            }
          } else {
            this.$message.error(`${res.data.message}`)
          }
        })
    },
    // 获取应付总表数据
    getFinanceOutAllList(query) {
      this.$API
        .FinanceOutAllList({
          number: query,
          writeoffStatus: 'wei_he_xiao:writeoff_status',
        })
        .then((res) => {
          if (res.data.status === 'success') {
            let data = res.data.result?.data || []
            this.baseInForm.financeOutAmount += Number(data[0].settlementAmount)
            this.tableConfig.tableData.push(data[0])
            if (this.tableConfig.tableData.length == 1) {
              this.baseInForm.objectStatus = data[0].objectStatus
              this.baseInForm.objectName = data[0].objectName
            }
          } else {
            this.$message.error(`${res.data.message}`)
          }
        })
    },
    // 远程搜索值改变的时候
    changeVal(e) {
      this.CheckedData = {}
      let arr = this.numberArr
      let index = arr.findIndex((element) => element.number == e)
      if (this.numberArr[index]) this.CheckedData = this.numberArr[index]

      console.log(this.CheckedData)
    },

    // 获取结算对象类型
    // getConfDictValDownList(PARAM) {
    //   this.$API.wtl_getConfDictValDownList({ dictType: PARAM }).then((res) => {
    //     if (res.data.status === "success") {
    //       this.objectStatusArr = res.data.result || [];
    //     } else {
    //       console.log(res.data.message);
    //     }
    //   });
    // },

    // 获取业务网点（组织架构列表）
    GetDept() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === 'success') {
          let result = res.data.result?.data || []
          this.businessDeptIdArr = result
          this.reconciliationDeptIdArr = result
        }
      })
    },

    // 修改时，获取对账单单条数据
    GetStatementList(number) {
      this.$API.StatementList({ number }).then((res) => {
        if (res.data.status === 'success') {
          let result = res.data.result?.data || []
          this.baseInForm = result[0] || this.baseInForm
          this.baseInFormlast = {
            financeInAmount: this.baseInForm.financeInAmount,
            financeOutAmount: this.baseInForm.financeOutAmount,
            settlementAmount: this.baseInForm.settlementAmount,
          }
          if (result.length > 0) {
            this.GetStatementFinanceListID = result[0].statementId
            this.getData()
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 修改时，根据对账单id获取财务列表 handleSizeChange
    getData() {
      let queryData = {
        statementId: this.GetStatementFinanceListID,
        pageTotal: this.pageTotal,
        pageStart: this.pageStart,
      }
      this.$API.StatementFinanceList(queryData).then((res) => {
        if (res.data.status === 'success') {
          this.tableConfig.tableData = res.data.result?.data || []
          for (let u in this.tableConfig.tableData) {
            let _result = {}
            _result.operationType = 'UNCHANGED'
            _result.financeId = this.tableConfig.tableData[u].financeId
            _result.financeType = this.tableConfig.tableData[u].financeType
            _result.number = this.tableConfig.tableData[u].number
            this.DefaultTableData.push(_result)
          }

          this.pageCount = res.data.result?.pageCount || 0
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e
    },
    // 分页的方法
    handleSizeChange(val) {
      this.pageTotal = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageStart = val
      this.getData()
    },
    // 分页的方法
    handleSizeChange3(val) {
      this.queryData3.pageTotal = val
      this.clickQuery3()
    },
    handleCurrentChange3(val) {
      this.queryData3.pageStart = val
      this.clickQuery3()
    },
    // 分页的方法
    handleSizeChange4(val) {
      this.queryData4.pageTotal = val
      this.clickQuery4()
    },
    handleCurrentChange4(val) {
      this.queryData4.pageStart = val
      this.clickQuery4()
    },
    // 生成对账单
    createBill() {
      // 正常提交
      let param = {
        statementMoth: this.baseInForm.statementMoth,
      }
      for (let key in this.defaultBaseInForm) {
        if (this.baseInForm[key] || this.baseInForm[key] == 0) {
          eval('param.' + key + "='" + this.baseInForm[key] + "'")
        } else {
          eval('param.' + key + "=''")
        }
      }
      if (this.baseInForm.statementId)
        param.statementId = this.baseInForm.statementId
      param.financeReqs = []
      // param
      // if()
      if (param.statementId) {
        // 修改对账单
        for (let i in this.tableConfig.tableData) {
          let flag = this.DefaultTableData.findIndex(
            (elem) => elem.financeId === this.tableConfig.tableData[i].financeId
          )
          if (flag == -1) {
            param.financeReqs.push({
              financeId: this.tableConfig.tableData[i].financeId,
              financeType: this.tableConfig.tableData[i].financeType,
              operationType: 'ADD',
            })
          }
          if (
            flag != -1 &&
            this.DefaultTableData[flag].operationType == 'UNCHANGED'
          ) {
            param.financeReqs.push({
              financeId: this.tableConfig.tableData[i].financeId,
              financeType: this.tableConfig.tableData[i].financeType,
              operationType: 'UNCHANGED',
            })
          }
          if (
            flag != -1 &&
            this.DefaultTableData[flag].operationType == 'DEL'
          ) {
            param.financeReqs.push({
              financeId: this.tableConfig.tableData[i].financeId,
              financeType: this.tableConfig.tableData[i].financeType,
              operationType: 'DEL',
            })
          }
        }
        this.$API.updateStatement(param).then((res) => {
          if (res.data.status === 'success') {
            this.$message.success(res.data.message)
            this.$TOOLS.closePage()
            this.$router.push({
              path: '/FM/BillWriteoff',
              query: {
                isreload: 'isreload',
              },
            })
          }
        })
      } else {
        // 新建对账单
        for (let i in this.tableConfig.tableData) {
          param.financeReqs.push({
            financeId: this.tableConfig.tableData[i].financeId,
            financeType: this.tableConfig.tableData[i].financeType,
          })
        }
        this.$API.createStatement(param).then((res) => {
          if (res.data.status === 'success') {
            this.$message.success(res.data.message)
            this.$TOOLS.closePage()
            this.$router.push({
              path: '/FM/BillWriteoff',
              query: {
                isreload: 'isreload',
              },
            })
          }
        })
      }
    },
    // 打印
    prite() {},
    // 表格移除事件
    remove(event, opt) {
      if (opt) this.selectTableData = [opt]
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      } else {
        this.$confirm('确认移除所选数据?', '提示:')
          .then((res) => {
            let data = this.selectTableData
            let TD = this.tableConfig.tableData
            for (let i in data) {
              let index = this.tableConfig.tableData.findIndex(
                (element) => element.financeId == data[i].financeId
              )
              let D_index = this.DefaultTableData.findIndex(
                (elem) => elem.financeId == data[i].financeId
              )
              if (D_index != -1) {
                this.DefaultTableData[D_index].operationType = 'DEL'
              }
              // 计算结算金额 & 核准金额 &
              // this.baseInForm.settlementAmount -= Number(
              //   this.tableConfig.tableData[index].settlementAmount
              // );
              // this.baseInForm.approvalAmount -= Number(
              //   this.tableConfig.tableData[index].settlementAmount
              // );
              // 计算应收应付
              if (TD[index].financeType == 'financeIn') {
                this.baseInForm.financeInAmount -=
                  this.tableConfig.tableData[index].settlementAmount
              } else {
                this.baseInForm.financeOutAmount -=
                  this.tableConfig.tableData[index].settlementAmount
              }
              this.tableConfig.tableData.splice(index, 1)
            }
            if (TD.length === 0) {
              this.baseInForm.objectStatus = ''
              this.baseInForm.objectName = ''
            }
            this.selectTableData = []
          })
          .catch((err) => {
            if (opt) this.selectTableData.length = 0
          })
      }
    },
    // 添加应收应付单
    ADDARAP() {
      this.isShowDialog = true
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia()
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.formData = {
        category: 1,
      }
      this.isShowDialog = false
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      let arr = Object.keys(this.CheckedData)
      let index = this.tableConfig.tableData.findIndex(
        (element) => element.number == this.CheckedData.number
      )
      let Dindex = this.DefaultTableData.findIndex(
        (e) => e.number == this.CheckedData.number
      )
      if (Dindex != -1) {
        this.DefaultTableData[Dindex].operationType = 'UNCHANGED'
      }
      let len = this.tableConfig.tableData.length
      let unified = true
      if (len == 0) {
        this.baseInForm.objectStatus = this.CheckedData.objectStatus
        this.baseInForm.objectName = this.CheckedData.objectName
      }
      if (len > 0) {
        if (
          this.CheckedData.objectName !==
          this.tableConfig.tableData[0].objectName
        ) {
          unified = false
        }
      }
      if (arr.length !== 0 && index == -1 && unified) {
        this.tableConfig.tableData.push(this.CheckedData)
        // 计算应收应付金额
        if (this.formData.category == 1) {
          this.baseInForm.financeInAmount += Number(
            this.CheckedData.settlementAmount
          )
        } else {
          this.baseInForm.financeOutAmount += Number(
            this.CheckedData.settlementAmount
          )
        }
        // 计算结算金额 & 核准金额
        // this.baseInForm.settlementAmount += Number(
        //   this.CheckedData.settlementAmount
        // );
        // this.baseInForm.approvalAmount += Number(
        //   this.CheckedData.settlementAmount
        // );
        this.formData = {
          category: 1,
        }
        this.isShowDialog = false
      } else {
        this.$message.warning('该数据结算对象不一样')
        return false
      }
    },
    height() {
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight
      let queryHeigth = this.$refs.formPanel.offsetHeight + 50
      let btnListHeight = this.$refs.btns.offsetHeight
      let pagsHeigth = 40 + 20
      let otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60
      this.$nextTick(() => {
        this.tableConfig.tableHeigth = Math.floor(windonHeight - otherHeight)
      })
    },
  },
}
</script>
<style scoped lang="less">
#ClearingBill {
  .saveBtn {
    padding: 10px 20px;
  }
  .formPanel {
    padding: 10px 20px;
    margin: 12px 0;
    background: rgba(0, 0, 0, 0.05);
    /deep/ .el-form-item {
      background: #fff !important;
    }
  }
  .btns {
    background: rgba(0, 0, 0, 0.05);
    .BillBtns {
      border: 1px solid #606266;
      background-color: #fff;
      color: #333;
      padding: 5px 10px;
      margin: 8px 0;
      margin-left: 10px;
    }
    .el-button:hover {
      border: 1px solid #ef7c0a;
      color: #ef7c0a;
    }
  }
}
.hasMoreParam {
  .glo_btnItems {
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
  }
}
</style>

